import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { EdsSpecificFieldTypes } from '@/features/eds/enums/EdsFieldTypes';
import { DocumentSlots } from '@/domains/documents/enums/DocumentSlots';
import { theme } from '@/styles/theme/theme';

export const documentVersionsOverride = {
  [EdsEntityCodes.Person]: {
    fullName: {
      fieldGroup: DocumentSlots.VersionRight,
      displayTitle: null,
      isEditable: false,
      metadata: {
        icon: null,
        value: {
          textVariant: 'subtitle2',
          color: theme.palette.text.primary,
          styles: {
            padding: '0px',
          },
        },
      },
    },
  },
  [EdsEntityCodes.Account]: {
    profileAvatar: {
      fieldGroup: DocumentSlots.VersionRight,
      fieldType: EdsSpecificFieldTypes.Avatar,
      isEditable: false,
      metadata: {
        icon: {
          size: 24,
        },
      },
    },
  },
};
